/* Fantombryg SEO V5 product ranking, installed as the existing V4 theme asset.
   Only reads Shopify storefront product JSON; never changes pages or publishes content. */
(function () {
  'use strict';
  var stop = new Set(['gave','gaver','til','med','den','der','det','som','for','fra','og','en','et','personlig','specialøl','øl','fantombryg']);
  var giftTerms = /gave|svende|pension|fødselsdag|jubilæum|jul|far|mor|mand|kvinde|tømrer|håndværker/i;
  var rejectAccessories = /strømper|sokker|glas|merch|t-shirt|kasket|plakat/i;
  var giftProducts = /gave|gaveæske|smagekasse|blindsmagning|personlig|design din egen|specialøl|tømrer|toemrer|håndværker|haandvaerker/i;
  function tokens(s) {
    return (s || '').toLocaleLowerCase('da-DK').match(/[a-zæøå0-9]+/g)?.filter(function(t){return t.length > 2 && !stop.has(t);}) || [];
  }
  function rank(product, subject) {
    var title = (product.title || '').toLocaleLowerCase('da-DK');
    var tags = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
    var hay = title + ' ' + (product.product_type || '').toLocaleLowerCase('da-DK') + ' ' + tags.toLocaleLowerCase('da-DK');
    var words = Array.from(new Set(tokens(subject)));
    var matches = words.filter(function(word){return hay.includes(word);}).length;
    var isGift = giftTerms.test(subject);
    if (isGift && rejectAccessories.test(title) && matches === 0) return -1;
    if (isGift && matches === 0 && !giftProducts.test(title)) return -1;
    var score = matches * 10;
    if (isGift && giftProducts.test(title)) score += 4;
    if (isGift && /tømrer|toemrer/.test(subject) && /tømrer|toemrer/.test(hay)) score += 25;
    if (!isGift && !matches) return -1;
    return score;
  }
  function money(value, cents) {
    if (value === null || value === undefined || value === '') return null;
    var amount = Number(value);
    return Number.isFinite(amount) && amount >= 0 ? amount / (cents ? 100 : 1) : null;
  }
  function priceNode(copy, product, cents) {
    var variants = (product.variants || []).filter(function(v){return v.available !== false;});
    var prices = variants.map(function(v){return money(v.price,cents);}).filter(function(p){return p !== null;});
    var p = document.createElement('p');
    p.className = 'fb-product-price';
    if (!prices.length) { p.textContent = 'Se pris på produktsiden'; copy.appendChild(p); return; }
    var min = Math.min.apply(null,prices);
    var formatter = new Intl.NumberFormat('da-DK',{style:'currency',currency:'DKK'});
    p.textContent = (new Set(prices).size > 1 ? 'Fra ' : '') + formatter.format(min);
    copy.appendChild(p);
    if (new Set(prices).size === 1) {
      var compares = variants.filter(function(v){return money(v.price,cents) === min;}).map(function(v){return money(v.compare_at_price,cents);}).filter(function(v){return v !== null && v > min;});
      if (compares.length) {
        var del = document.createElement('del');
        del.className = 'fb-product-compare-price';
        del.textContent = formatter.format(Math.min.apply(null,compares));
        copy.appendChild(del);
      }
    }
  }
  function render(section, products, cents) {
    var rail = section.querySelector('.fb-product-rail');
    if (!rail) return;
    var subject = section.getAttribute('data-subject') || '';
    var current = section.getAttribute('data-current-product') || '';
    var ranked = products.filter(function(p){return p && p.handle && '/products/' + p.handle !== current;})
      .map(function(p){return {product:p,score:rank(p,subject)};})
      .filter(function(entry){return entry.score >= 0;})
      .sort(function(a,b){return b.score-a.score;}).slice(0,10);
    if (!ranked.length) {
      section.hidden = true;
      section.dataset.fbCarouselStatus = 'no-relevant-products';
      return;
    }
    ranked.forEach(function(entry){
      var product = entry.product;
      var article = document.createElement('article');
      var image = product.featured_image || (product.images && product.images[0] && (product.images[0].src || product.images[0]));
      if (image) {
        var img = document.createElement('img');
        img.src = typeof image === 'string' ? image : image.src;
        img.alt = product.title || '';
        img.loading = 'lazy';
        article.appendChild(img);
      }
      var copy = document.createElement('div');
      copy.className = 'fb-product-copy';
      var title = document.createElement('h3');
      title.textContent = product.title || '';
      copy.appendChild(title);
      priceNode(copy,product,cents);
      var link = document.createElement('a');
      link.className = 'fb-button';
      link.href = '/products/' + encodeURIComponent(product.handle);
      link.textContent = 'Se produkt →';
      copy.appendChild(link);
      article.appendChild(copy);
      rail.appendChild(article);
    });
    section.dataset.fbCarouselStatus = 'loaded';
  }
  function candidateCollections(section) {
    var subject = (section.getAttribute('data-subject') || '').toLocaleLowerCase('da-DK');
    var original = section.getAttribute('data-collection') || '';
    var paths = [];
    function add(path) {
      if (/^\/collections\/[a-z0-9-]+\/?$/.test(path) && paths.indexOf(path) === -1) paths.push(path);
    }
    // Try the most specific collections first. The original SEO page collection
    // remains in the list, and unavailable collections simply return no products.
    if (/tømrer|toemrer|håndværker|haandvaerker|svende|pension/.test(subject)) {
      add('/collections/haandvaerker');
      add('/collections/personlige-ol');
    }
    if (/gave|fødselsdag|jubilæum|jul|far|mor|mand|kvinde/.test(subject)) {
      add('/collections/personlige-ol');
      add('/collections/gaveaesker');
    }
    add(original);
    if (/gave|svende|pension|tømrer|toemrer|håndværker|haandvaerker/.test(subject)) add('/collections/fantombryg');
    return paths.slice(0,5);
  }
  function loadCollection(path) {
    return fetch(path.replace(/\/$/,'') + '/products.json?limit=100',{headers:{Accept:'application/json'}})
      .then(function(response){if(!response.ok) return [];return response.json().then(function(data){return data.products || [];});})
      .catch(function(){return [];});
  }
  function initialize() {
    document.querySelectorAll('.fb-related-products[data-fb-carousel="v4"]').forEach(function(section){
      if (section.dataset.fbInitialized === '1') return;
      section.dataset.fbInitialized = '1';
      var rail = section.querySelector('.fb-product-rail');
      if (!rail) {section.hidden = true;return;}
      section.querySelectorAll('[data-direction]').forEach(function(button){
        button.addEventListener('click',function(){
          rail.scrollBy({left:Number(button.getAttribute('data-direction')) * rail.clientWidth * 0.8,behavior:'smooth'});
        });
      });
      var collections = candidateCollections(section);
      if (!collections.length) {section.hidden = true;return;}
      Promise.all(collections.map(loadCollection)).then(function(groups){
        var seen = new Set();
        var products = [];
        groups.forEach(function(group){
          group.forEach(function(product){
            if (!product.handle || seen.has(product.handle)) return;
            seen.add(product.handle);
            products.push(product);
          });
        });
        render(section,products,false);
      }).catch(function(){section.hidden = true;section.dataset.fbCarouselStatus = 'load-error';});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();